import React from 'react';

import { Grid, Section } from '@gogame/components';

export const GeneralSection = ({
  parentCampaign,
  campaign,
  label,
  owner,
  ownerManagement,
  type,
  autoNameSwitch,
}) => {
  return (
    <Section title={'General'}>
      <Grid container spacing={3}>
        <Grid item xs={12}>
          {parentCampaign}
        </Grid>
        <Grid item xs={autoNameSwitch ? 8 : 12}>
          {campaign}
        </Grid>
        {autoNameSwitch && (
          <Grid item xs={4}>
            {autoNameSwitch}
          </Grid>
        )}
        <Grid item xs={4}>
          {type}
        </Grid>
        <Grid item xs={4}>
          {label}
        </Grid>
        <Grid item xs={4}>
          {owner}
        </Grid>
        <Grid item>{ownerManagement}</Grid>
      </Grid>
    </Section>
  );
};
